import React, { forwardRef } from 'react';
import { usePress } from 'react-aria';
import { Button, ButtonProps } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

// A button-like component that allows movement of finger after touch start and before touch end.
export interface TouchButtonProps extends Omit<ButtonProps, 'component'> {
  component?: React.ElementType;
  isSpinning?: boolean;
}

export const TouchButton = forwardRef<HTMLElement, TouchButtonProps>((props, ref) => {
  const { component: Component = Button, onClick, children, isSpinning, startIcon, ...other } = props;

  const { pressProps } = usePress({
    onPress: (e) => {
      onClick?.(e as unknown as React.MouseEvent<HTMLButtonElement>);
    },
  });

  return (
    <Component
      {...other}
      {...pressProps}
      startIcon={isSpinning ? <CircularProgress color="inherit" size={20} /> : startIcon}
      ref={ref}
      sx={{ touchAction: 'none', WebkitTapHighlightColor: 'transparent', ...other?.sx }}
    >
      {children}
    </Component>
  );
});

TouchButton.displayName = 'TouchButton';
